import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { jsPDF } from "jspdf";
import { exportDataGrid as exportPdfDataGrid } from "devextreme/pdf_exporter";
import { exportDataGrid as exportExcelDataGrid } from "devextreme/excel_exporter";
export const ExportFormats = {
  xlsx: ["xlsx"],
  pdf: ["pdf"],
  xlsxpdf: ["xlsx", "pdf"],
};
export const exportDataGrid = (e, title, pictureColIndex = 0) => {
  if (e.format === "pdf") {
    // const doc = new jsPDF("p", "pt", "a4", "portrait", "landscap");
    const doc = new jsPDF({
      orientation: "l",
      unit: "pt",
      format: [1224, 970],
      //putOnlyUsedFonts: true,
    });

    const lastPoint = { x: 0, y: 0 };
    //doc.setFontSize(12);
    exportPdfDataGrid({
      jsPDFDocument: doc,
      component: e.component,
      topLeft: { x: 1, y: 15 },
      //columnWidths: [40, 40, 30, 30, 40],
      indent: 15,
      onRowExporting: (e) => {
        const isPictueHeader = e.rowCells[pictureColIndex].text === "Picture";
        if (!isPictueHeader) {
          e.rowHeight = 40;
        }
      },
      customizeCell({ gridCell, pdfCell }) {
        if (
          gridCell.rowType === "data" &&
          gridCell.column.dataField === "Phone"
        ) {
          pdfCell.text = pdfCell.text.replace(
            /(\d{3})(\d{3})(\d{4})/,
            "($1) $2-$3"
          );
        } else if (gridCell.rowType === "group") {
          pdfCell.backgroundColor = "#BEDFE6";
        } else if (gridCell.rowType === "totalFooter") {
          pdfCell.font.style = "italic";
        }
      },
      customDrawCell(options) {
        const { gridCell, pdfCell, rect } = options;
        pdfCell.font.size = 8;
        if (lastPoint.x < rect.x + rect.w) {
          lastPoint.x = rect.x + rect.w;
        }
        if (lastPoint.y < rect.y + rect.h) {
          lastPoint.y = rect.y + rect.h;
        }
        if (
          gridCell.rowType === "data" &&
          gridCell.column.dataField === "Website"
        ) {
          options.cancel = true;
          doc.setFontSize(11);
          doc.setTextColor("#0000FF");

          const textHeight = doc.getTextDimensions(pdfCell.text).h;
          doc.textWithLink(
            "website",
            options.rect.x + pdfCell.padding.left,
            options.rect.y + options.rect.h / 2 + textHeight / 2,
            { url: pdfCell.text }
          );
        }
        if (
          gridCell.rowType === "data" &&
          gridCell.column.dataField === "Picture"
        ) {
          doc.addImage(
            gridCell.value,
            "PNG",
            e.rect.x,
            e.rect.y,
            e.rect.w,
            e.rect.h
          );
          e.cancel = true;
        }
      },
    })
      .then(() => {
        doc.setFontSize(12);
        doc.setTextColor("#cccccc");
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageSize = doc.internal.pageSize;
          const pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();

          //Title
          doc.setFontSize(15);
          doc.setTextColor("#cccccc");
          doc.text(title, 40, 15, { baseline: "top" });
          //const titleWidth = doc.getTextDimensions(title).w;
          // doc.text(title, (pageWidth - titleWidth) / 2, 15, {
          //   baseline: "top",
          // });
          //Footer
          const footerPageNumber = `Page ${i} of ${pageCount}`;
          doc.setTextColor("#cccccc");
          doc.text(
            footerPageNumber,
            pageWidth / 2 - doc.getTextWidth(footerPageNumber) / 2,
            pageHeight - 15,
            { baseline: "bottom" }
          );
          //Footer Url
          const footerUrl = "https://zenplus.utwiz.com/";
          doc.setFontSize(9);
          doc.setTextColor("#cccccc");
          doc.text(
            footerUrl,
            pageWidth - (doc.getTextWidth(footerUrl) + 50),
            pageHeight - 15,
            { baseline: "bottom" }
          );
        }
      })
      .then(() => {
        //const title = `${title}`;
        // const pageWidth = doc.internal.pageSize.getWidth();
        // doc.setFontSize(15);
        // doc.setTextColor("#cccccc");
        // const titleWidth = doc.getTextDimensions(title).w;
        //doc.text(title, (pageWidth - titleWidth) / 2, 20);
        // const footer = "www.zenplus.utwiz.com";
        // doc.setFontSize(9);
        // doc.setTextColor("#cccccc");
        // const footerWidth = doc.getTextDimensions(footer).w;
        // doc.text(footer, lastPoint.x - footerWidth, lastPoint.y + 5);
        doc.save(`${e.fileName}.pdf`);
      });
    e.cancel = true;
  }
  if (e.format === "xlsx") {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(e.fileName);

    exportExcelDataGrid({
      component: e.component,
      worksheet,
      //autoFilterEnabled: true,
      topLeftCell: { row: 4, column: 1 },
      customizeCell: ({ gridCell, excelCell }) => {
        if (gridCell.rowType === "data") {
          if (gridCell.column.dataField === "Phone") {
            excelCell.value = parseInt(gridCell.value, 10);
            excelCell.numFmt = "[<=9999999]###-####;(###) ###-####";
          }
          if (gridCell.column.dataField === "Website") {
            excelCell.value = {
              text: gridCell.value,
              hyperlink: gridCell.value,
            };
            excelCell.font = { color: { argb: "FF0000FF" }, underline: true };
            excelCell.alignment = { horizontal: "left" };
          }
          if (gridCell.column.dataField === "Picture") {
            excelCell.value = undefined;
            const image = workbook.addImage({
              base64: gridCell.value,
              extension: "png",
            });
            worksheet.getRow(excelCell.row).height = 90;
            worksheet.addImage(image, {
              tl: { col: excelCell.col - 1, row: excelCell.row - 1 },
              br: { col: excelCell.col, row: excelCell.row },
            });
          }
        }
        if (gridCell.rowType === "group") {
          excelCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "BEDFE6" },
          };
        }
        if (gridCell.rowType === "totalFooter" && excelCell.value) {
          excelCell.font.italic = true;
        }
      },
    })
      .then((cellRange) => {
        // titel
        const titleRow = worksheet.getRow(2);
        titleRow.height = 18;
        worksheet.mergeCells(2, 1, 2, cellRange.to.column);
        titleRow.getCell(1).value = title;
        titleRow.getCell(1).font = {
          color: { argb: "FFFF0000" },
          name: "Segoe UI Light",
          size: 12,
          bold: true,
        };
        titleRow.getCell(1).alignment = { horizontal: "left" };
        titleRow.getCell(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "BFBFBF",
          },
        };
        // header
        const headerRow = worksheet.getRow(4);
        //headerRow.height = 20;
        headerRow.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "eeeeee" },
          };
          cell.font = { name: "Arial", size: 12 };
          cell.alignment = { horizontal: "center" };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        // footer
        const footerRowIndex = cellRange.to.row + 2;
        const footerRow = worksheet.getRow(footerRowIndex);
        worksheet.mergeCells(
          footerRowIndex,
          2,
          footerRowIndex,
          cellRange.to.column
        );
        let totalRecords = cellRange.to.row - 4 > 0 ? cellRange.to.row - 4 : 0;
        footerRow.getCell(1).value = `Record(s) : ${totalRecords}`;
        footerRow.getCell(1).font = {
          color: { argb: "000000" },
          italic: true,
        };
        footerRow.getCell(1).alignment = { horizontal: "right" };
        footerRow.getCell(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "D3D3D3",
          },
        };
        footerRow.getCell(2).value = {
          text: "www.zenplus.utwiz.com",
          hyperlink: "https://zenplus.utwiz.com/",
        };
        footerRow.getCell(2).font = {
          color: { argb: "0000FF" },
          italic: true,
        };
        footerRow.getCell(2).alignment = { horizontal: "right" };
        footerRow.getCell(2).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: {
            argb: "D3D3D3",
          },
        };
      })
      .then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            `${e.fileName}.xlsx`
          );
        });
      });
    e.cancel = true;
  }
};

// export async function exportDataGrid(fileName, title, footer) {
//   const onExportingPdf = React.useCallback((e) => {
//     const doc = new jsPDF();
//     const lastPoint = { x: 0, y: 0 };

//     exportPdfDataGrid({
//       jsPDFDocument: doc,
//       component: e.component,
//       topLeft: { x: 1, y: 15 },
//       columnWidths: [30, 20, 30, 15, 22, 22, 20, 20],
//       customDrawCell({ rect }) {
//         if (lastPoint.x < rect.x + rect.w) {
//           lastPoint.x = rect.x + rect.w;
//         }
//         if (lastPoint.y < rect.y + rect.h) {
//           lastPoint.y = rect.y + rect.h;
//         }
//       },
//     }).then(() => {
//       const title = `${title}`;
//       const pageWidth = doc.internal.pageSize.getWidth();
//       doc.setFontSize(15);
//       const titleWidth = doc.getTextDimensions(title).w;
//       doc.text(title, (pageWidth - titleWidth) / 2, 20);
//       const footer = "www.zenplus.utwizh.com";
//       doc.setFontSize(9);
//       doc.setTextColor("#cccccc");
//       const footerWidth = doc.getTextDimensions(footer).w;
//       doc.text(footer, lastPoint.x - footerWidth, lastPoint.y + 5);
//       doc.save(`${fileName}.pdf`);
//     });
//   });

//   const onExportingExcel = (e) => {
//     const workbook = new Workbook();
//     const worksheet = workbook.addWorksheet(fileName);

//     exportExcelDataGrid({
//       component: e.component,
//       worksheet,
//       topLeftCell: { row: 4, column: 1 },
//     })
//       .then((cellRange) => {
//         // title
//         const titleRow = worksheet.getRow(2);
//         titleRow.height = 30;
//         worksheet.mergeCells(2, 1, 2, 8);

//         titleRow.getCell(1).value = title;
//         titleRow.getCell(1).font = { name: "Segoe UI Light", size: 22 };
//         titleRow.getCell(1).alignment = { horizontal: "center" };

//         // footer
//         const footerRowIndex = cellRange.to.row + 2;
//         const footerRow = worksheet.getRow(footerRowIndex);
//         worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 8);

//         footerRow.getCell(1).value = "www.zenplus.utwiz.com";
//         footerRow.getCell(1).font = { color: { argb: "BFBFBF" }, italic: true };
//         footerRow.getCell(1).alignment = { horizontal: "right" };
//       })
//       .then(() => {
//         workbook.xlsx.writeBuffer().then((buffer) => {
//           saveAs(
//             new Blob([buffer], { type: "application/octet-stream" }),
//             `${fileName}.xlsx`
//           );
//         });
//       });
//     e.cancel = true;
//   };
//   return { onExportingPdf, onExportingExcel };
// }
